import React, { MouseEvent } from 'react';
import styles from './styles.module.css';

interface DropdownItemProps {
  children: React.ReactNode;
  onClick: (e: MouseEvent) => void;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  onClick,
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      className={styles.item}
    >
      {children}
    </div>
  );
};
